export const getVwoScript = ({ accountId, baseUrl }) => `
  window._vwo_code ||
    (function () {
      var account_id = ${accountId},
        version = 2.2,
        settings_tolerance = 2000,
        hide_element = 'body',
        hide_element_style =
          'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
        f = false,
        w = window,
        d = document,
        v = d.querySelector('#vwoCode'),
        cK = '_vwo_' + account_id + '_settings',
        cc = {};
      try {
        var c = JSON.parse(localStorage.getItem('_vwo_' + account_id + '_config'));
        cc = c && typeof c === 'object' ? c : {};
      } catch (e) {}
      var st = cc.stT === 'session' ? w.sessionStorage : w.localStorage;
      var code = {
        nonce: v && v.nonce,
        use_existing_jquery: function () {
          return typeof use_existing_jquery !== 'undefined'
            ? use_existing_jquery
            : undefined;
        },
        library_tolerance: function () {
          return typeof library_tolerance !== 'undefined'
            ? library_tolerance
            : undefined;
        },
        settings_tolerance: function () {
          return cc.sT || settings_tolerance;
        },
        hide_element_style: function () {
          return '{' + (cc.hES || hide_element_style) + '}';
        },
        hide_element: function () {
          if (performance.getEntriesByName('first-contentful-paint')[0]) {
            return '';
          }
          return typeof cc.hE === 'string' ? cc.hE : hide_element;
        },
        getVersion: function () {
          return version;
        },
        finish: function (e) {
          if (!f) {
            f = true;
            var t = d.getElementById('_vis_opt_path_hides');
            if (t) {
              t.parentNode.removeChild(t);
            }
            if (e) {
              new Image().src = '${baseUrl}/ee.gif?a=' + account_id + e;
            }
          }
        },
        finished: function () {
          return f;
        },
        addScript: function (e) {
          var t = d.createElement('script');
          t.type = 'text/javascript';
          if (e.src) {
            t.src = e.src;
          } else {
            t.text = e.text;
          }
          if (code.nonce) {
            t.setAttribute('nonce', code.nonce);
          }
          d.getElementsByTagName('head')[0].appendChild(t);
        },
        load: function (e, t) {
          var n = this;
          t = t || {};
          var r = new XMLHttpRequest();
          r.open('GET', e, true);
          r.withCredentials = !t.dSC;
          r.responseType = t.responseType || 'text';
          r.onload = function () {
            if (t.onloadCb) {
              return t.onloadCb(r, e);
            }
            if (r.status === 200) {
              n.addScript({ text: r.responseText });
            } else {
              w._vwo_code.finish('&e=loading_failure:' + e);
            }
          };
          r.onerror = function () {
            if (t.onerrorCb) {
              return t.onerrorCb(e);
            }
            w._vwo_code.finish('&e=loading_failure:' + e);
          };
          r.send();
        },
        init: function () {
          if (d.URL.indexOf('__vwo_disable__') > -1) {
            return;
          }
          var e = this.settings_tolerance();
          w._vwo_settings_timer = setTimeout(function () {
            w._vwo_code.finish();
            st.removeItem(cK);
          }, e);
          var t;
          if (this.hide_element() === 'body') {
            t = d.createElement('style');
            t.setAttribute('id', '_vis_opt_path_hides');
            if (code.nonce) {
              t.setAttribute('nonce', code.nonce);
            }
            t.setAttribute('type', 'text/css');
            if (t.styleSheet) {
              t.styleSheet.cssText =
                this.hide_element() + this.hide_element_style();
            } else {
              t.appendChild(
                d.createTextNode(
                  this.hide_element() + this.hide_element_style()
                )
              );
            }
            d.getElementsByTagName('head')[0].appendChild(t);
          } else {
            t = d.getElementsByTagName('head')[0];
            var n = d.createElement('div');
            n.style.cssText =
              'z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;';
            n.setAttribute('id', '_vis_opt_path_hides');
            n.classList.add('_vis_hide_layer');
            t.parentNode.insertBefore(n, t.nextSibling);
          }
          var s =
            '${baseUrl}/j.php?a=' +
            account_id +
            '&u=' +
            encodeURIComponent(d.URL) +
            '&vn=' +
            version;
          this.load(s + '&x=true');
        },
      };
      w._vwo_code = code;
      code.init();
    })();
`;

export const VWO_SCRIPT_ID = "vwoCode";
export const VWO_PRECONNECT_ID = "vwoPreconnect";
export const VWO_HIDE_STYLE_ID = "_vis_opt_path_hides";
